import emailjs from 'emailjs-com'

const FromContact = () => {
  const sendEmail = (e) => {
    console.log('activo')
    e.preventDefault()

    emailjs.sendForm(
      'service_2oiyy2o',
      'template_rfeym94',
      e.target,
      'xMrfr23hZeVa59UfT'
    )
      .then(function (response) {
        console.log('SUCCESS!', response.status, response.text)
        alert('Correo enviado !')
      }, function (error) {
        console.log(error)
        alert('Revise bien la informacion !.')
      })
  }
  return (
    <form onSubmit={sendEmail}>
      <p className='text-red-400 sm:md:text-2xl text-sm font-medium sm:md:mx-10 sm:md:px-10 mx-2 px-2 mb-6 text-left'>Envíanos tu solicitud</p>
      <div className='mb-6'>
        <label className='block mb-2 text-sm font-medium text-white'>Tu nombre <span className='text-red-500'>*</span></label>
        <input name='name' type='text' className='bg-red-50 border border-red-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5 dark:border-red-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-red-500 dark:focus:border-red-500' />
      </div>
      <div className='mb-6'>
        <label className='block mb-2 text-sm font-medium text-white'>Tu correo <span className='text-red-500'>*</span></label>
        <input name='email' type='email' className='bg-red-50 border border-red-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5 dark:border-red-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-red-500 dark:focus:border-red-500' placeholder='ventas@dmgroup.mx' />
      </div>
      <div className='mb-6'>
        <label className='block mb-2 text-sm font-medium text-white'>Tu telefono <span className='text-red-500'>*</span></label>
        <input name='tel' type='tel' className='bg-red-50 border border-red-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5 dark:border-red-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-red-500 dark:focus:border-red-500' placeholder='55-1392-0600' />
      </div>
      <div className='mb-6'>
        <label className='block mb-2 text-sm font-medium text-white'>Mensaje</label>
        <textarea name='message' rows='4' className='bg-red-50 border border-red-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5 dark:border-red-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-red-500 dark:focus:border-red-500'> </textarea>
      </div>
      <div className='mb-6 grid justify-items-center'>
        <button className='bg-red-500 hover:bg-red-700 px-12 py-2 text-lg font-medium rounded text-white' type='submit'>Enviar</button>
      </div>
    </form>
  )
}

export default FromContact
